const url = '/service'

module.exports = {
    url
}